import moment from 'moment';
import { mapValues } from 'lodash';

import { STATES_MAP } from 'src/constants';
export * from './rollbar';
export * from './styled';
export * from './formatters';
export * from './filters';
export * from './formik';
export * from './validation';
export * from './imageProcessing';
export * from './capitalizeFirstLetter';
export * from './applicant';

export const isFunction = (obj: any): obj is Function => typeof obj === 'function';

export const canUseDOM = () =>
  Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);

export const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

const { origin = '', protocol = '', host = '' } = canUseDOM() ? window.location : {};

export const hostname = host
  .split('.')
  .slice(-2)
  .join('.');

export const parseUrl = url => {
  const a = document.createElement('a');
  a.href = url;
  return a;
};

export const getUrlDomain = () => {
  const a = parseUrl(window.location.href);
  return a.hostname;
};

export const getSubDomain = () => window.location.hostname.split('.')[0];

export const composeFullUrl = (path: string, companySlug = 'www') => {
  return `${protocol}//${companySlug}.${hostname}${path}`;
};

export const getCompanySlug = () => window.location.hostname.split('.')[0];
export const getCurrentFullUrl = pathname => `${origin}${pathname}`;

export function checkIfDuplicateExists(w) {
  return new Set(w).size !== w.length;
}

export const getCSRFTokenContent = () => {
  if (!canUseDOM()) return '';
  const metas = window.document.getElementsByTagName('meta');

  for (let i = 0; i < metas.length; i += 1) {
    if (metas[i].getAttribute('name') === 'csrf-token') {
      return metas[i].getAttribute('content');
    }
  }

  return '';
};

export const humanizeDate = date => {
  if (moment(date).isValid()) {
    if (moment(date).isSame(moment(), 'day')) {
      return moment(date).format('h:mm A');
    }
    if (moment(date).isSame(moment().subtract(1, 'day'), 'day')) {
      return 'Yesterday';
    }

    return moment(date).format('DD MMM. YYYY');
  }

  return date;
};

export function createMarkup(str) {
  let result = `<p>${str}</p>`;
  result = result.replace(/\r\n\r\n/g, '</p><p>').replace(/\n\n/g, '</p><p>');
  result = result.replace(/\r\n/g, '<br />').replace(/\n/g, '<br />');

  return {
    __html: result
  };
}

export function createEmailMarkup(str) {
  return {
    __html: str
  };
}

export const isWithdrawn = applicant => applicant && applicant.state === STATES_MAP.withdrawn;

export const getObjectKeysMap = object => mapValues(object, (value, key) => key);
